import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import parse from 'html-react-parser'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import { colors } from '../components/Colors'
import imgDiferenciais from '../img/prot-neuro.jpg'
import imgHipotermia from '../img/hipotermia.jpg'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimentoCentros from '../components/CentralAtendimentoUtis'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  .offsetImgMid.gatsby-image-wrapper{
    float: left;
    width: 485px;
    margin: 0 40px 0 0;
  }
  .offsetImgStart.gatsby-image-wrapper{
    width: 50%;
    
  }
}
`

const GroupContent = styled.section`
  padding: 2em 0;

  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }

  .icons {
    flex-wrap: wrap !important;
    div {
      width: 50%;
      @media ${device.mobileL} {
        width: 100%;
        min-width: 100%;
      }
    }
    ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
      li {
        width: 50%;
        min-width: 50%;
        box-sizing: border-box;
        padding: 1em;
        font-size: 0.8em;
        @media ${device.mobileL} {
          width: 100%;
          min-width: 100%;
          text-align: left;
        }
        img {
          width: 40px;
          height: auto;
          margin: 0 10px 0 0;
          vertical-align: middle;
        }
      }
    }
  }
  .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    img {
      margin: 0;
      height: 100%;
      @media ${device.mobileL} {
        margin: 0;
        height: auto;
        width: 100%;
      }
    }
    div {
      img {
        float: left;
        margin: 0 40px 0 0;
      }
    }
    div.first {
      margin-right: 75px;
      width: 58%;
      @media ${device.mobileL} {
        width: 100%;
        margin-right: 0px;
        order: 2;
      }
    }
  }

  .lista {
    h4 {
      margin-top: 4em;
    }
    ul {
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /**
      Target IE11
      */
        width: 1180px;
      }
      li {
        margin: 0 1em 1em 0;
        padding: 1.5em;
        list-style: none;
        background: #ffffff;
        color: ${colors.cinza};
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
        position: relative;
        min-height: 40px;
        box-sizing: border-box;
        width: 47%;
        display: flex;
        align-items: flex-start;
        @media ${device.mobileL} {
          width: 100%;
          padding: 1em;
          margin: 0 0 1em 0;
          flex-wrap: wrap;
          text-align: left;
        }
        svg {
          font-size: 3em;
          padding: 0 0.5em 0 0;
          flex: none;
          color: ${colors.verde};
        }
      }
    }
  }
  :nth-of-type(odd) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
  }
  :nth-of-type(even) {
    h3 {
      color: #8e8fc7;
    }
  }
  :nth-of-type(5) {
    background: ${colors.verdeGradiente};
    .lista {
      ul {
        li {
          flex-wrap: wrap;
          justify-content: center;
          align-content: flex-start;
          h3 {
            font-size: 3em;
            margin-bottom: 0.5em;
            color: ${colors.verde};
          }
          p {
            width: 100%;
            strong {
              color: ${colors.verde};
            }
          }
        }
      }
    }
  }
`
export const UtiNeonatalNeurologicaTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Estrutura',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          height="189px"
          right="0px"
          bottom="0px"
          imgWidth="44%"
          overflow="visible"
          imgInner
          mobileTop="-18%"
        />
        <GroupContent>
          <div className="inner center">
            <div className="first">{parse(sessoes[0].texto)}</div>
            {sessoes[0].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[0].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Unidade de
                  Terapia Intensiva"
                className="offsetImgStart"
              />
            ) : (
              <img
                src={sessoes[0].imagemDaSessao.sourceUrl}
                alt="Unidade de
                  Terapia Intensiva"
                className="offsetImgStart"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner lista center">
            <div>
              <h3>{parse(sessoes[1].tituloDaSessao)}</h3>
              {parse(sessoes[1].texto)}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h3>{parse(sessoes[2].tituloDaSessao)}</h3>
              {sessoes[2].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[2].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Hipotermia"
                  className="offsetImgMid"
                />
              ) : (
                <img
                  src={sessoes[2].imagemDaSessao.sourceUrl}
                  alt="Hipotermia"
                  className="offsetImgMid"
                />
              )}
              {parse(sessoes[2].texto)}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner lista center">
            <div>
              <h3>{parse(sessoes[3].tituloDaSessao)}</h3>

              <ul>
                {sessoes[3].listaDeItens.map((item, index) => (
                  <li key={index}>{parse(item.item)}</li>
                ))}
              </ul>
            </div>
          </div>
        </GroupContent>
        <CentralAtendimentoCentros
          title="Entre em contato pela nossa central"
          central="Central de atendimento"
          telefone=""
        />
      </Container>
    </>
  )
}

UtiNeonatalNeurologicaTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const UtiNeonatalNeurologica = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <UtiNeonatalNeurologicaTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

UtiNeonatalNeurologica.propTypes = {
  data: PropTypes.object.isRequired,
}

export default UtiNeonatalNeurologica

export const UtiNeonatalNeurologicaQuery = graphql`
  query UtiNeonatalNeurologicaById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
